const hotelSearchInput = (tripId, isTripSearch) => (store) => {
  if (isTripSearch) {
    return {
      searchInputs: store.tripSearch.searchInputs.hotel,
      searchObj: store.tripSearch.searchObj.hotel,
      selectedAddress:
        store.tripSearch.searchObj.hotel && store.tripSearch.searchObj.hotel.selectedAddress,
      searchProgress:
        store.tripSearch.searchObj.hotel && store.tripSearch.searchObj.hotel.searchProgress,
    };
  }
  const { searchInputs, searchObj, selectedAddress, searchProgress } =
    store.hotel.hotelSearches[tripId] || {};
  return {
    searchObj: !searchObj ? {} : searchObj,
    searchInputs: !searchInputs ? {} : searchInputs,
    selectedAddress,
    searchProgress,
  };
};
export default hotelSearchInput;
